import styled from '@emotion/styled';
import { Space } from 'antd';

export const SadaApplicantFormAppointment = styled.div``;

export const FormAppointmentBlock = styled(Space)`
  width: 100%;
  max-width: 400px;
`;
